(function attachRbsVariantSelection(root) {
  function selectForOptionChange(variants, requestedOptions, changedIndex) {
    if (!Array.isArray(variants) || !Array.isArray(requestedOptions)) return null;

    const exact = variants.find((variant) =>
      Array.isArray(variant.options) &&
      variant.options.length === requestedOptions.length &&
      variant.options.every((value, index) => value === requestedOptions[index]),
    );
    if (exact) return exact;

    if (
      !Number.isInteger(changedIndex) ||
      changedIndex < 0 ||
      changedIndex >= requestedOptions.length ||
      !requestedOptions[changedIndex]
    ) {
      return null;
    }

    const candidates = variants
      .map((variant, index) => ({ variant, index }))
      .filter(
        ({ variant }) =>
          Array.isArray(variant.options) &&
          variant.options.length === requestedOptions.length &&
          variant.options[changedIndex] === requestedOptions[changedIndex],
      )
      .sort((left, right) => {
        const matchingOtherOptions = ({ variant }) =>
          variant.options.reduce(
            (count, value, index) =>
              count +
              Number(index !== changedIndex && value === requestedOptions[index]),
            0,
          );
        return (
          matchingOtherOptions(right) - matchingOtherOptions(left) ||
          Number(right.variant.available === true) -
            Number(left.variant.available === true) ||
          left.index - right.index
        );
      });

    return candidates[0]?.variant || null;
  }

  root.RbsVariantSelection = Object.freeze({ selectForOptionChange });
})(typeof window === "undefined" ? globalThis : window);
